import script from "./BrandLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandLogo.vue?vue&type=script&setup=true&lang=js"

import "./BrandLogo.vue?vue&type=style&index=0&id=e64d4182&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e64d4182"]])

export default __exports__